import React, { Component } from 'react'
import './_styles.scss'
import Translator from '../../../../../../../../../requests/apa/Translator'
import Utils from '../../../../../../../../../utils/Utils'
import Device from '../../../../../../../../../devices/device'

/**
 * Toggle
 * Interruptor visual reutilizable con 4 estados.
 * Diseño: Figma node 87:15082 / 87:15085 / 87:15088
 *
 * Props:
 *  active {bool}   — activado (knob izquierda, fondo morado) o no (knob derecha, fondo gris)
 *  label  {string} — texto opcional a la izquierda del toggle
 */
class Toggle extends Component {
  constructor (props) {
    super(props)
    this.state = {
      focused: false
    }
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.keys = Device.getDevice().getKeys()
  }

  handleFocus () { this.setState({ focused: true }) }
  handleBlur () { this.setState({ focused: false }) }

  handleKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey !== 'OK') return
    e.preventDefault()
    var nextActive = !this.props.active
    if (typeof this.props.onChange === 'function') this.props.onChange(nextActive)
  }

  render () {
    var active = !!this.props.active
    // var label = this.props.label
    var label = this.props.label
    var focused = this.state.focused

    var className = 'toggle'
    if (active) className += ' toggle--active'
    if (focused) className += ' toggle--focused'

    var pill = (
      <div
        className={className}
        tabIndex={0}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onKeyDown={this.handleKeyDown}
      >
        <div className='toggle__knob' />
      </div>
    )

    if (!label) return pill

    return (
      <div className='toggle-container'>
        <p className='toggle__label'>{label}</p>
        {pill}
      </div>
    )
  }
}

export default Toggle



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/Toogle/index.jsx